import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {Link} from 'react-router-dom';
import Util from '../../../forecast-app/shared/util/util';
import ResolveMovedTimelogTaskMutation from '../../../mutations/resolve_moved_timelog_task_mutation';

class TimeLogErrorView extends Component {
	resolve(task) {
		Util.CommitMutation(ResolveMovedTimelogTaskMutation, {
			id: task.id,
			companyId: this.props.viewer.company.id,
		});
	}

	closeModal() {
		this.props.close();
	}

	render() {
		return (
			<div className="layer">
				<div className="fullscreen fullscreen-centered-outer timelog-errors">
					<div className="fullscreen-centered-inner">
						<div className="fullscreen-centered-content">
							<h1>Opgaver som ligger i forkerte Timelog projekter</h1>
							<h3>{'Tidsregistreringer på nedenstående opgaver bliver ikke synkroniseret til TimeLog, da opgaven ligger i et andet Timelog projekt end det det Forecast opgavens projekt er knyttet til.'}</h3>
							<h3>{"Tryk på 'Marker som løst' når opgaven er flyttet til det korrekte Timelog projekt."}</h3>
							<table className="timelog-table">
								<thead>
									<tr>
										<th style={{width: '100%'}}>Opgave</th>
										<th />
									</tr>
								</thead>
								<tbody>
									{this.props.movedTasks.edges.map((taskEdge, index) => {
										const task = taskEdge.node;
										return (
											<tr className="time-reg-line-item" key={'economic-time-reg-line-' + index}>
												<td style={{verticalAlign: 'middle'}} className={'field'}>
													<Link className="react-router-link" to={'/settings/catalog/timelog/T' + task.companyTaskId}>
														{'T' + task.companyTaskId + ' ' + task.name}
													</Link>
												</td>
												<td style={{verticalAlign: 'middle'}}>
													<button className="resolve-button" onClick={this.resolve.bind(this, task)}>
														Marker som løst
													</button>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
							<div>
								<button className="timelog-button" onClick={this.closeModal.bind(this)} disabled={false}>
									Luk
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(TimeLogErrorView);
